import { createStyles, IconButton, Theme, withStyles } from "@material-ui/core";
import * as React from "react";
import AppIcon from "./AppIcon";
import { AppIconType } from "./AppIconType";
import ColorTooltip from "./ColorTooltip";

const styles = (theme: Theme) => createStyles({
    appBarIcon: {
        height: 24,
        width: 24,
    },
    appBarIconButton: {
        // color: theme.palette.text.primary,
    },
    appIcon: {
        marginLeft: theme.spacing(),
    },
    focus: {

    }
});

interface ITooltipIconButtonProps {
    button: boolean;
    classes?: {
        appBarIconButton: string;
        appBarIcon: string;
        appIcon: string;
        focus: string;
    };
    className?: string;
    icon: AppIconType;
    onClick?: (event: React.MouseEvent<HTMLButtonElement | SVGSVGElement | HTMLImageElement, MouseEvent>) => void;
    open?: boolean;
    placement: "bottom-end" | "bottom-start" | "bottom" |
                "left-end" | "left-start" | "left" |
                "right-end" | "right-start" | "right" |
                "top-end" | "top-start" | "top";
    title?: string;
    style?: React.CSSProperties;
    hidden?: boolean;
}

interface ITooltipIconButtonState {
    tooltipVisible: boolean;
}

class TooltipIconButton extends React.Component<ITooltipIconButtonProps, ITooltipIconButtonState> {

    private enterTimer?: number;
    private leaveTimer?: number;

    /**
     *
     */
    constructor(props: ITooltipIconButtonProps) {
        super(props);

        this.state = {
            tooltipVisible: props.open || false,
        };
    }

    public render() {

        const {button, hidden} = this.props;

        if (hidden)  {
            return <> </>;
        }
        

        if (!button) {
            return this.renderIcon();
        } else {
            return this.renderButton();
        }
    }

    public componentWillUnmount() {
        if (this.enterTimer) {
            window.clearTimeout(this.enterTimer);
        }
    }

    private getButton = () => {
        const { classes, icon, title } = this.props;

        if (icon.indexOf("http") > -1) {
            return <img src={icon} alt={title} className={classes!.appBarIcon} />;
        }

        return <AppIcon icon={icon as AppIconType} titleAccess={title} className={classes!.appBarIconButton} />;
    }

    private renderButton = () => {
        const { className, onClick, placement, style, title} = this.props;

        return <ColorTooltip title={title || ''}
                             placement={placement}
                             style={style}
                             open={this.state.tooltipVisible || this.props.open}>
            <IconButton
                className={className}
                
                style={{ 
                    ...style,
                    marginTop: -4, 
                    marginBottom: 4 
                }}
                onMouseEnter={() => this.onMouseEnter()}
                onMouseLeave={() => this.onMouseLeave()}
                onClick={onClick}>
                    {  this.getButton() }
            </IconButton>
        </ColorTooltip>;
    }


    private getIcon = () => {
        const { classes, icon, onClick, style, title } = this.props;

        if (icon.indexOf("http") > -1) {
            return <img src={icon} 
                alt={title} 
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                onClick={onClick}
                style={style}
                className={classes!.appBarIconButton} 
            />;
        }

        return  <AppIcon icon={icon}
            className={classes!.appIcon}
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
            onClick={onClick}
            style={style}
            color="inherit" />;
    }

    private renderIcon = () => {
        const {placement, style, title} = this.props;

        return <ColorTooltip title={title || ''}
                    placement={placement}
                    style={style}
                    open={this.state.tooltipVisible || this.props.open}>
                        { this.getIcon() }
        </ColorTooltip>;
    }

    private onMouseEnter = () => {
        this.enterTimer = window.setTimeout(() => {

            this.setState({tooltipVisible: true});
            this.leaveTimer = window.setTimeout(() => this.onMouseLeave(), 3000);

        }
        , 700);
    }

    private onMouseLeave = () => {
        this.setState({tooltipVisible: false});

        if (this.enterTimer) {
            window.clearTimeout(this.enterTimer);
            delete this.enterTimer;
        }

        if (this.leaveTimer) {
            window.clearTimeout(this.leaveTimer);
            delete this.leaveTimer;
        }
    }

}

export default withStyles(styles, {withTheme: true })(TooltipIconButton);
